import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../../TreeNode';
import { InstructionNodeFactory, InstructionNodeProps } from '../InstructionNodeFactory';
import { LeftPaneContext } from '../../../LeftPaneContext';
import { CombinedInstruction, Axis } from '../../../../../../machinelogic/types';
import { toJS } from "mobx";
import { gReservedUuids as reservedActuatorUuids } from "../../../../../../machinelogic/constants/ReservedUuids";


interface CombinedInstructionNodeProps extends Omit<InstructionNodeProps, 'instruction'> {
  instruction: CombinedInstruction
}

const getInstructionLabelName = (instruction: CombinedInstruction): string => {

  switch(instruction.name) {
    case "moveRelativeCombined":
      return `Move Relative Combined`;
    case "moveAbsoluteCombined":
      return `Move Absolute Combined`;
  }
};


// TODO: Confirm if highlight correct
export const CombinedNode: FC<CombinedInstructionNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const { library } = useContext(LeftPaneContext);

  interface AxisItem {
    name: string;
    position_or_distance: string;
    unit: string;
  }

  let axes: AxisItem[];
  switch(instruction.name) {
    case "moveRelativeCombined":
      axes = instruction.parameters.axes
        .filter(axisItem => axisItem.axis)
        .map(axisItem => {
          if (axisItem.axis === reservedActuatorUuids.UNKNOWN) {
            return {
              name: 'UNKNOWN axis',
              position_or_distance: axisItem.distance,
              unit: 'mm'
            };
          }
          const axis = library.getConfigManager().getAxisByUuid(axisItem.axis);
          return {
            name: axis?.name,
            position_or_distance: axisItem.distance,
            unit: axis?.unit || 'mm'
          };
        });
      break;
    case "moveAbsoluteCombined":
      axes = instruction.parameters.axes
        .filter(axisItem => axisItem.axis)
        .map(axisItem => {
          if (axisItem.axis === reservedActuatorUuids.UNKNOWN) {
            return {
              name: 'UNKNOWN axis',
              position_or_distance: axisItem.position,
              unit: 'mm'
            };
          }
          const axis = library.getConfigManager().getAxisByUuid(axisItem.axis);
          return {
            name: axis?.name,
            position_or_distance: axisItem.position,
            unit: axis?.unit || 'mm'
          };
        });
      break;
  }

  const instructionLabel = <TreeNodeLabel
    icon='icon-motor'
    name={getInstructionLabelName(instruction)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode
      title={instructionLabel}
      titleClassName={titleClassName}
      isCollapsible={axes.length > 0}
      isDefaultExpanded={false}
    >
      {axes.length > 0 && axes
        .map((axisItem, index) => {
          return(
            <TreeNode
              key={index}
              title={<TreeNodeLabel name={`${axisItem.name} by ${axisItem.position_or_distance} ${axisItem.unit}`} onClick={onClick} />}
            />
          );})
      }
    </TreeNode>
  );
});

